<div
  class="dashboard-tile"
  [class.dashboard-tile--active]="this.summary?.antalFejl && isactive"
  [class.dashboard-tile--enabled]="this.summary?.antalFejl && !isactive"
  [class.dashboard-tile--disabled]="!this.summary?.antalFejl"
  [class.dashboard-tile--loading]="this.isLoading"
  (click)="setactive()"
  >
  @if (isLoading) {
    <span class="loading loading--dark"></span>
  }
  @if (!isLoading) {
    <mat-icon [svgIcon]="ikon" class="icon-48" [class.mat-icon--red]="this.summary?.antalFejl && isactive"></mat-icon>
  }
  <div class="dashboard-tile__data">
    <div class="dashboard-tile__title">{{ title }}</div>
    <div class="dashboard-tile__text">{{ antalFejl }}</div>
  </div>
</div>
